// extracted by mini-css-extract-plugin
export default {"movieCard":"MovieCard_movieCard__779Nd","image":"MovieCard_image__IYYUm","title":"MovieCard_title__YUymp"};